// src/config/index.js
import { INTEGRATION_TYPE } from "../utils/constant";

/**
 * @typedef {object} SDKConfig
 * @property {string} apiUrl
 * @property {string} secretKey
 * @property {string} apiKey
 * @property {string} verificationId
 * @property {string} customerId
 * @property {string} integrationType
 * @property {object} [userData]
 * @property {string} [token]
 */

const defaultConfig = {
  apiUrl: "",
  secretKey: "",
  apiKey: "",
  verificationId: "",
  customerId: "",
  integrationType: "",
  userData: undefined,
  token: undefined,
};

/** @type {SDKConfig} */
let config = { ...defaultConfig };

export const setConfig = (newConfig) => {
  const { apiUrl, secretKey, apiKey, verificationId, integrationType } =
    newConfig;

  if (!apiUrl || !secretKey || !apiKey || !verificationId || !integrationType) {
    throw new Error(
      "Apacuana SDK: La configuración inicial debe incluir apiUrl, " +
        "secretKey, apiKey, verificationId e integrationType."
    );
  }

  // Nueva validación para el valor de integrationType
  if (!Object.values(INTEGRATION_TYPE).includes(integrationType)) {
    throw new Error(
      `Apacuana SDK: El valor de integrationType ('${integrationType}') no es válido. ` +
        `Valores permitidos: ${Object.values(INTEGRATION_TYPE).join(", ")}`
    );
  }

  config = { ...config, ...newConfig };
  // eslint-disable-next-line no-console
};

export const getConfig = () => ({ ...config });

export const close = () => {
  config = { ...defaultConfig };
};
